import React from 'react'

import EditorialContactForm from '@/component/Primitive/EditorialContactForm'
import createFormSubmissionContainer from '../../../../lib/submitter'
import createSchema from '../../../../../components/site/editorial-contact-form/lib/schema'

const schema = createSchema()

const EditorialContactFormContainer = () => {
  const EditorialContactFormComponent = (props) => (
    <EditorialContactForm {...props} />
  )

  const ContainerComponent = createFormSubmissionContainer({
    Component: EditorialContactFormComponent,
    schema,
    apiUrl: '/api/editorial-contact-form'
  })

  return <ContainerComponent />
}

export default EditorialContactFormContainer
